import React from 'react';
import '../assets/css/Totd.css';

const Support = () => {
  return (
    <div className="container">
      <section className="ctext section-body" id="support" data-rv-view="0">
        <div className="filter-container">
          <div className="container">
            <div className="row">
              <div className="totdText">
                <h3>RippaDay Support</h3>
                <p>Need help with your RippaDay account, members access, subscription, password, or app experience?</p>

                <h4>Contact</h4>
                <p>Email: <a href="mailto:support@rippaday.com">support@rippaday.com</a></p>
                <p>Privacy questions: <a href="mailto:privacy-policy@rippaday.com">privacy-policy@rippaday.com</a></p>

                <h4>Account and subscription help</h4>
                <p>If you contact support about an account or subscription, please use the email address linked to your RippaDay account and include the device platform you use, such as iOS, Android, or web.</p>
                <p>For account deletion, visit <a href="/account-deletion/">rippaday.com/account-deletion/</a>.</p>

                <h4>Responsible gambling</h4>
                <p>RippaDay information is for entertainment purposes only. Gamble responsibly. Australian users can visit <a href="https://www.gamblinghelponline.org.au/">Gambling Help Online</a> for support.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Support;
